/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import observeIntersection from '../inc/observeIntersection';
import scriptLoader from '../inc/scriptLoader';

const renderMaps = (el) => {
// ############### Map Box Functions ###############
    const geojson = {
        type: 'FeatureCollection',
        features: [],
    };
    let bounds = [];
    const accessToken = window.mapBoxToken;
    const mapContainer = el;
    let map = '';
    const currentMarkers = [];
    const mapMarkers = JSON.parse(
        window.mapContainers.find((e) => e.containerId === el).markers
    );

    let zoom = 9;
    if (mapMarkers.length === 1) {
        zoom = JSON.parse(
            window.mapContainers.find((e) => e.containerId === el).zoom
        );
    }

    getGeoJson();

    function getGeoJson() {
        gatherGeoJson();

        // Init Map
        initMap(geojson.features[0].geometry.coordinates);

        map.on('load', async() => {
            mapLoaded();
        });
    }

    function gatherGeoJson() {
        // Sammel alle Daten
        bounds = [];
        geojson.features = [];

        for (let i = 0; i < mapMarkers.length; i += 1) {
            const coordinates = [
                parseFloat(mapMarkers[i].location.lng, 10),
                parseFloat(mapMarkers[i].location.lat, 10),
            ];
            const featuresData = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates,
                },
                properties: {
                    tooltip: mapMarkers[i].tooltip,
                },
            };
            bounds.push(coordinates);
            geojson.features.push(featuresData);
        }
    }

    function updateMap() {
        gatherGeoJson();

        map.getSource('locations').setData(geojson);
        addMarkers(geojson);

        if (geojson.features.length > 1) {
            fitMapToFeatures(geojson);
        }
    }

    function initMap(center) {
    // Set center
        mapboxgl.accessToken = accessToken;

        // Create Map Box Object & Options
        map = new mapboxgl.Map({
            container: mapContainer,
            style: window.mapBoxStyleUrl,
            center,
            zoom,
        });

        // Map Settings
        map.addControl(new mapboxgl.NavigationControl(), 'top-left');
        map.scrollZoom.disable();
        $(`#${mapContainer}`).one('click touch', () => {
            map.scrollZoom.enable();
        });
    }

    function mapLoaded() {
        map.addSource('locations', {
            type: 'geojson',
            data: geojson,
        });
        addMarkers(geojson);

        updateMap();
    }

    function fitMapToFeatures(featuresToFit) {
        bounds = new mapboxgl.LngLatBounds();
        if (featuresToFit.type === 'FeatureCollection') {
            featuresToFit.features.forEach((feature) => {
                bounds.extend(feature.geometry.coordinates);
            });
        } else {
            featuresToFit.geometry.coordinates[0].forEach((coordinate) => {
                bounds.extend(coordinate);
            });
        }

        map.fitBounds(bounds, {
            padding: 100
        });
    }

    function addMarkers(data) {
        if (currentMarkers !== null) {
            for (let i = currentMarkers.length - 1; i >= 0; i -= 1) {
                currentMarkers[i].remove();
            }
        }
        /* For each feature in the GeoJSON object above: */
        data.features.forEach((marker) => {
        /* Create a div element for the marker. */
            const markerEl = document.createElement('div');
            /* Assign a unique `id` to the marker. */
            markerEl.id = `marker-${marker.properties.id}`;
            /* Assign the `marker` class to each marker for styling. */
            markerEl.className = 'marker';

            markerEl.innerHTML = '<svg width="30" height="37" viewBox="0 0 30 37" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 36.5467L25.6067 25.94C27.7044 23.8422 29.133 21.1695 29.7118 18.2598C30.2906 15.3501 29.9935 12.3341 28.8582 9.5932C27.7229 6.85232 25.8003 4.50965 23.3335 2.86144C20.8668 1.21323 17.9667 0.333496 15 0.333496C12.0333 0.333496 9.13321 1.21323 6.66647 2.86144C4.19974 4.50965 2.27715 6.85232 1.14183 9.5932C0.00651145 12.3341 -0.290549 15.3501 0.288214 18.2598C0.866978 21.1695 2.29557 23.8422 4.39334 25.94L15 36.5467ZM15 11C12.7909 11 11 12.7909 11 15C11 17.2091 12.7909 19 15 19C17.2091 19 19 17.2091 19 15C19 12.7909 17.2091 11 15 11Z" fill="currentColor" /></svg>';
            /* *
       * Create a marker using the div element
       * defined above and add it to the map.
       * */

            let popupContent = `<div class="popupContent"><h2>${marker.properties.tooltip.headline}</h2><p>${marker.properties.tooltip.text}</p></div>`;

            if (marker.properties.tooltip.image) {
                popupContent = `<img src="${marker.properties.tooltip.image.sizes.sm}">${popupContent}`;
            }

            if (marker.properties.tooltip.link.url && marker.properties.tooltip.link.title) {
                popupContent = `${popupContent}<a class="btn arrow" href="${marker.properties.tooltip.link.url}"`;

                if (marker.properties.tooltip.link.target === '_blank') {
                    popupContent += `target="${marker.properties.tooltip.link.target}"`;
                }
                popupContent += `>${marker.properties.tooltip.link.title}</a>`;
            }

            const oneMarker = new mapboxgl.Marker(markerEl, { anchor: 'bottom' })
                .setLngLat(marker.geometry.coordinates).setPopup(new mapboxgl.Popup({ offset: 0 })
                    .setHTML(popupContent))
                .addTo(map);
            currentMarkers.push(oneMarker);
        });
    }

    //#############

    // mapboxgl.accessToken = window.mapBoxToken;

    // const mapMarkers = JSON.parse(
    //     window.mapContainers.find((e) => e.containerId === el).markers
    // );
    // const center = [
    //     mapMarkers[0].location.lng,
    //     mapMarkers[0].location.lat,
    // ];

    // const map = new mapboxgl.Map({
    //     container: el, // container ID
    //     center, // starting position [lng, lat]
    //     zoom: 13, // starting zoom
    //     // pitch: 50,
    //     style: window.mapBoxStyleUrl, // style URL or style object
    // });

    // map.addControl(new mapboxgl.NavigationControl(), 'top-right');

    // if (mapMarkers.length > 0) {
    //     const markerLocations = [];
    //     mapMarkers.forEach((mrkr) => {
    //         markerLocations.push([
    //             parseFloat(mrkr.location.lng, 10),
    //             parseFloat(mrkr.location.lat, 10),
    //         ]);
    //         // eslint-disable-next-line max-len
    //         let popupContent = `<div class="popupContent"><h2>${mrkr.tooltip.headline}</h2><p>${mrkr.tooltip.text}</p></div>`;
    //         if (mrkr.tooltip.image) {
    //             popupContent = `<img src="${mrkr.tooltip.image.sizes.sm}">${popupContent}`;
    //         }

    //         if (mrkr.tooltip.link.url && mrkr.tooltip.link.title) {
    //             popupContent = `${popupContent}<a class="btn arrow" href="${mrkr.tooltip.link.url}"`;

    //             if (mrkr.tooltip.link.target === '_blank') {
    //                 popupContent += `target="${mrkr.tooltip.link.target}"`;
    //             }
    //             popupContent += `>${mrkr.tooltip.link.title}</a>`;
    //         }

    //         const popup = new mapboxgl.Popup({
    //             offset: 25,
    //         }).setHTML(popupContent);

    //         const popUpContainer = document.createElement('div');
    //         popUpContainer.id = 'marker';
    //         popUpContainer.innerHTML = '<svg width="30" height="37" viewBox="0 0 30 37" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 36.5467L25.6067 25.94C27.7044 23.8422 29.133 21.1695 29.7118 18.2598C30.2906 15.3501 29.9935 12.3341 28.8582 9.5932C27.7229 6.85232 25.8003 4.50965 23.3335 2.86144C20.8668 1.21323 17.9667 0.333496 15 0.333496C12.0333 0.333496 9.13321 1.21323 6.66647 2.86144C4.19974 4.50965 2.27715 6.85232 1.14183 9.5932C0.00651145 12.3341 -0.290549 15.3501 0.288214 18.2598C0.866978 21.1695 2.29557 23.8422 4.39334 25.94L15 36.5467ZM15 11C12.7909 11 11 12.7909 11 15C11 17.2091 12.7909 19 15 19C17.2091 19 19 17.2091 19 15C19 12.7909 17.2091 11 15 11Z" fill="currentColor" /></svg>';

    //         new mapboxgl.Marker(popUpContainer, {
    //             offset: [-15, -37]
    //         }).setLngLat([
    //             parseFloat(mrkr.location.lng, 10),
    //             parseFloat(mrkr.location.lat, 10),
    //         ]).setPopup(popup)
    //             .addTo(map);
    //     });

    //     if (markerLocations.length > 1) {
    //         map.fitBounds(markerLocations, {
    //             padding: 100
    //         });
    //     }
    // }
};

const initMap = (el, isIntersecting) => {
    if (isIntersecting) {
        if (!window.mapboxgl) {
            scriptLoader(
                [`${themeVars.assetsUrl}dist/js/mapbox/mapbox-gl.js`],
                renderMaps,
                el.target.id
            );
        } else {
            renderMaps(el.target.id);
        }
    }
};

window.initMapObserver = () => {
    observeIntersection('.mapBlock', initMap, true);
};
